export default "__VITE_ASSET__BPomLXHj__"